import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { dashboardService } from '../services';
import { LayoutDashboard, ArrowRight } from 'lucide-react';
import './UserDashboards.css';

const UserDashboards = () => {
  const [dashboards, setDashboards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    loadDashboards();
  }, []);

  const loadDashboards = async () => {
    try {
      const data = await dashboardService.getAll();
      setDashboards(data);
    } catch (error) {
      setError('Failed to load dashboards');
    } finally {
      setLoading(false);
    }
  };

  const handleDashboardClick = (dashboard) => {
    navigate(`/dashboard/${dashboard.dashboard_id}`);
  };

  return (
    <div className="user-dashboards-page">
      <Navbar />
      
      <div className="dashboards-container">
        <div className="dashboards-header">
          <h1>My Dashboards</h1>
          <p>Access your assigned dashboards and monitor your devices</p>
        </div>

        {error && <div className="alert alert-error">{error}</div>}

        {loading ? (
          <div className="loading">
            <div className="loading-spinner"></div>
            <p>Loading dashboards...</p>
          </div>
        ) : dashboards.length === 0 ? (
          <div className="empty-state">
            <LayoutDashboard size={64} />
            <h2>No Dashboards Assigned</h2>
            <p>Contact your administrator to get dashboard access</p>
          </div>
        ) : (
          <div className="dashboards-grid">
            {dashboards.map((dashboard) => (
              <div
                key={dashboard.id}
                className="dashboard-card"
                onClick={() => handleDashboardClick(dashboard)}
              >
                <div className="dashboard-icon">
                  <LayoutDashboard size={32} />
                </div>
                <div className="dashboard-info">
                  <h3>{dashboard.name}</h3>
                  <p className="dashboard-description">{dashboard.description}</p>
                  <div className="dashboard-meta">
                    <span className="dashboard-type">{dashboard.type}</span>
                    {dashboard.device_id && (
                      <span className="device-id">Device: {dashboard.device_id}</span>
                    )}
                  </div>
                </div>
                <div className="dashboard-action">
                  <ArrowRight size={24} />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default UserDashboards;
